/**
 * AffiliateWelcomeBanner — the AFFILIATE-referred merchant's 7-day welcome
 * (Part 5): "Welcome to Autonoma! You arrived via [affiliate name]'s
 * link. Enjoy your welcome bonus." with the small welcome pack it
 * unlocked (10 product searches + 3 product page generations).
 *
 * Mounted in AppLayout next to the peer ReferralWelcomeBanner; the
 * backend (GET /api/affiliate/welcome) owns the 7-day window and the
 * dismissal (POST /api/affiliate/welcome/dismiss).
 */
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Banner } from '@shopify/polaris';

import { HUB_ROUTE, dismissAffiliateWelcome, fetchAffiliateWelcome } from '../lib/affiliate';

export default function AffiliateWelcomeBanner({ shop }) {
  const navigate = useNavigate();
  const [welcome, setWelcome] = useState(null);

  useEffect(() => {
    if (!shop) return undefined;
    let alive = true;
    fetchAffiliateWelcome().then((w) => { if (alive && w?.show) setWelcome(w); }).catch(() => {});
    return () => { alive = false; };
  }, [shop]);

  if (!welcome) return null;
  const expires = welcome.expiresAt
    ? new Date(welcome.expiresAt).toLocaleDateString(undefined, { month: 'long', day: 'numeric' }) : null;
  const who = welcome.affiliateName ? `${welcome.affiliateName}\u2019s link` : 'an affiliate\u2019s link';

  return (
    <div style={{ padding: '12px 16px 0' }} data-testid="affiliate-welcome-banner">
      <Banner
        title={`Welcome to Autonoma! You arrived via ${who}. Enjoy your welcome bonus. 🎉`}
        tone="info"
        onDismiss={() => { setWelcome(null); dismissAffiliateWelcome(); }}
        action={{ content: 'Earn with Autonoma too', onAction: () => navigate(HUB_ROUTE) }}
      >
        <p>
          Your welcome bonus: <strong>{welcome.summary}</strong>, used before your monthly plan credits
          {expires ? ` and valid until ${expires}` : ''}.
          {welcome.daysLeft > 0 ? ` This note stays for ${welcome.daysLeft} more day${welcome.daysLeft === 1 ? '' : 's'}.` : ''}
        </p>
      </Banner>
    </div>
  );
}
